
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';
import { ConversionHelper } from '@/helpers/ConversionHelper';
import LeftDrawer from '../components/LeftDrawer.vue';
import ItemService from '@/services/item-service';
import { CustomerService } from '@/services/customer-service';
import ItemDownloadDialog from '@/components/ItemDownloadDialog.vue';
import ItemOrderDialog from '@/components/ItemOrderDialog.vue';
import ItemQuotesDialog from '@/components/ItemQuotesDialog.vue';
import ItemHoldDialog from '@/components/ItemHoldDialog.vue';
import ItemHistory from '@/components/ItemHistory.vue';
import ItemDeleteDialog from '@/components/ItemDeleteDialog.vue';
import ItemApprovalDialog from '@/views/ItemApproval.vue';
import ItemMergeDialog from './ItemMergeDialog.vue';
import ItemOrderProofDialog from '@/components/ItemOrderProofDialog.vue';
import ItemPartNumberEditDialog from '@/components/ItemPartNumberEditDialog.vue';
import AlertComponent from '@/components/AlertLayout.vue';
import { Item, ItemDetails } from '../store/models/ItemModel';
import {
  Orderline,
  OrderlineDetails,
  OrderlinePurchaseStateTypes,
  OrderPo,
  RushOption
} from '../store/models/OrderlineModel';
import { OrdersService } from '@/services/orders-service';
import ItemOrderProofDialogVue from './ItemOrderProofDialog.vue';
import DieService from '@/services/die-service';
import { SetSnackBar } from '@/helpers/SnackbarHelper';
@Component({
  components: {
    LeftDrawer,
    ItemOrderDialog,
    ItemQuotesDialog,
    ItemApprovalDialog,
    ItemHoldDialog,
    ItemDeleteDialog,
    ItemOrderProofDialog,
    AlertComponent,
    ItemPartNumberEditDialog,
    ItemMergeDialog,
    ItemHistory,
    ItemDownloadDialog
  }
})
export default class extends Vue {
  $refs!: {
    itemOrderDialog: HTMLFormElement;
    itemQuotesDialog: HTMLFormElement;
    ItemHoldDialog: HTMLFormElement;
    itemDeleteDialog: HTMLFormElement;
    ItemDownloadDialog: HTMLFormElement;
    itemOrderProofDialog: HTMLFormElement;
    itemPartNumberEditDialog: HTMLFormElement;
    ItemMergeDialog: HTMLFormElement;
    ItemHistory: HTMLFormElement;
  };

  @Getter('orderlines', { namespace: 'orderlines' })
  orderlines!: Orderline[];
  @Mutation('orderlinesLoaded', { namespace: 'orderlines' })
  setOrderlines!: any;
  @Mutation('addPOToList', { namespace: 'orderlines' })
  addPOToList!: any;
  @Action('GetCustomerItemsLimited', { namespace: 'items' })
  GetCustomerItemsLimited!: any;

  @Prop({ required: true }) item!: Item;
  @Prop() isImageLoading!: boolean;
  @Prop() fullView!: boolean;
  /* Store Actions */

  itemApprovalRestrictedDialog: boolean = false;
  itemDetail: ItemDetails | null = null;
  po: string = '';
  filename: string = '';
  isLoading: boolean = false;
  isDeleting: boolean = false;
  actionItems: Array<{
    id: number;
    action: string;
    icon: string;
    hidden: boolean;
    disabled: boolean;
  }> = [
    {
      id: 1,
      action: 'Edit/Update',
      icon: 'mdi-pencil',
      hidden: false,
      disabled: false
    },
    {
      id: 2,
      action: this.item.IsApproved ? 'Place on hold' : 'Approve Now',
      icon: this.item.IsApproved ? 'mdi-pause-circle-outline' : 'mdi-check-all',
      hidden: false,
      disabled: this.item.IsStaticItem
    },
    {
      id: 3,
      action: 'Barcode Placement',
      icon: 'mdi-data-matrix',
      hidden: false,
      disabled: this.item.IsStaticItem
    },
    {
      id: 5,
      action: 'Download',
      icon: 'mdi-cloud-download',
      hidden: false,
      disabled: this.item.IsStaticItem
    },
    {
      id: 4,
      action: 'Quick Quote',
      icon: 'mdi-poll',
      hidden: false,
      disabled: false
    },
    {
      id: 7,
      action: 'Item History',
      icon: 'mdi-history',
      hidden: false,
      disabled: false
    },
    {
      id: 8,
      action: 'Delete',
      icon: 'mdi-delete-forever',
      hidden: false,
      disabled: false
    }
  ];

  async handleEvent(action: string) {
    switch (action) {
      case 'Edit/Update':
        if (this.item.IsStaticItem) {
          this.$router.push({ name: 'addItem', params: { id: this.item.Id } });
        } else {
          this.$router.push({
            name: 'addCustomLabel',
            params: { itemId: this.item.Id }
          });
        }
        return;
      case 'Barcode Placement':
        this.$router.push({
          name: 'BarcodePlacement',
          params: { itemId: this.item.Id }
        });
        return;
      case 'Quick Quote':
        this.$refs.itemQuotesDialog.openDialog();
        return;
      case 'Item History':
        this.$refs.ItemHistory.openDialog();
        return;
      case 'Place on hold':
        this.$refs.ItemHoldDialog.openDialog();
        return;
      case 'Approve Now':
        if (this.item.Die.Id === 212) {
          this.itemApprovalRestrictedDialog = true;
        } else {
          this.$router.push({
            name: 'ItemApproval',
            params: { id: this.item.Id }
          });
        }
        return;
      case 'Download':
        await this.GetItemDetails(this.item.Id);
        this.$refs.ItemDownloadDialog.openDialog();
        return;
      case 'Delete':
        this.$refs.itemDeleteDialog.openDialog();
        return;
    }
  }
  openItemMergeDialog() {
    this.$refs.itemPartNumberEditDialog.closeDialog();
    this.$refs.ItemMergeDialog.openDialog();
  }
  async placeOnHold() {
    SetSnackBar('Putting item on hold...');
    await this.$store.dispatch('items/PlaceOnHold', this.item.Id);
    await this.$store.dispatch('items/refreshItem', this.item.Id);
    SetSnackBar('Item is now on hold');
    this.actionItems[4].action = 'Approve Item';
    // this.$emit('refreshItem', this.item.Id);
  }
  async deleteItem(shouldDelete: boolean) {
    if (shouldDelete) {
      this.isDeleting = true;
      this.$emit('deleteItem');
      SetSnackBar('Deleting item...');
      this.$refs.itemDeleteDialog.closeDialog();
      await this.$store.dispatch('items/DeleteItem', this.item.Id);
      await this.GetCustomerItemsLimited();
      SetSnackBar('Deleted Item successfully');
      this.isDeleting = false;
      if (this.fullView) {
        this.$router.push({
          name: 'ManageItems',
          params: { id: this.item.Id }
        });
      }
    }
  }
  async partNumberChanged() {
    await this.$store.dispatch('items/refreshItem', this.item.Id);
    SetSnackBar('Part Number Changed Successfully');
    this.$emit('refreshItem', this.item.Id);
  }
  async editItem(response: any) {
    if (response.didAccept) {
      let handleEditItem = response;
      if (this.fullView) {
        this.$emit('editItemCallback', handleEditItem);
        return;
      }
      this.$emit('handleEditItem', handleEditItem);
    }
  }

  async orderProof(response: any) {
    SetSnackBar('Ordering your proof...');
    const axiosresponse = await ItemService.RequestPhysicalProof(response);
    await this.$store.dispatch('items/refreshItem', this.item.Id);
    const model = {
      Pos: [axiosresponse.data.PO],
      page: 0
    };
    const responseOrderline = await OrdersService.GetOrderlinesByPO(model);

    if (this.orderlines[0]) {
      const proofOrderline = await OrdersService.RefreshOrderline(
        responseOrderline.data[0].Id
      );
      const newOrderline: Orderline[] = [new Orderline(proofOrderline.data)];
      let orderlinesWithAddedOl = [...newOrderline, ...this.orderlines];
      this.setOrderlines(orderlinesWithAddedOl);
    }
    SetSnackBar('Proof(s) were placed successfully');
    this.$refs.itemOrderProofDialog.closeDialog();
  }

  async refreshItemAndPo(po: string) {
    this.$store.dispatch('items/refreshItem', this.item.Id);
    this.addPOToList(
      new OrderPo({
        PO: po,
        Page: 1
      })
    );
  }

  async orderItem(response: any) {
    SetSnackBar('Ordering this item...');
    this.$refs.itemOrderDialog.setLoading(true);
    this.isLoading = true;
    try {
      const data = await CustomerService.GetCustomerPaymentProfiles();
      const defaultPayment = data.data.filter((p: any) => p.IsDefault == true);
      let model = {
        Orderlines: response.orderline.map((ol: OrderlineDetails) =>
          ConversionHelper.convertOrderlineToAddModel(ol)
        ),
        PO: response.selectedPO,
        State:
          response.orderline[0].OrderlinePurchaseStateType ===
          OrderlinePurchaseStateTypes.Create
            ? 'New'
            : 'Edit',
        ShipToId: 4,
        PaymentMethodProfileId: defaultPayment[0].PaymentProfileId,
        IsCartOrder: false,
        OrderType: 'Order Now'
      };
      const orderResponse = await OrdersService.PlaceOrder(model);
      const newOrderline: Orderline[] = orderResponse.data.map(
        (r: any) => new Orderline(r)
      );
      this.$store.dispatch('items/refreshItem', this.item.Id);
      await this.$store.dispatch('orderlines/ClearCurrentOrder');
      this.addPOToList(
        new OrderPo({
          PO: response.selectedPO,
          Page: 1
        })
      );
      this.isLoading = false;
      this.$refs.itemOrderDialog.closeDialog();
      SetSnackBar('Item ordered successfully');
    } catch (err) {
      console.log(err);
      this.isLoading = false;
      SetSnackBar(
        'Issue has occured while placing your order. Please try again or contact technical support if issue persists'
      );
    }
    this.$refs.itemOrderDialog.setLoading(false);
  }

  async GetItemDetails(itemId: string) {
    const response = await ItemService.GetItemDetails(itemId);
    if (response.data) {
      this.filename = response.data.FileName;
      this.itemDetail = response.data;
    }
  }
  openOrderProofDialog() {
    this.$refs.itemOrderProofDialog.openDialog();
  }
  setShouldItemRefreshToTrue(response: boolean) {
    this.$emit('setShouldItemRefreshToTrue', response);
  }
  async mounted() {
    this.actionItems[0].hidden = this.fullView;
  }
}
